@file:OptIn(InternalResourceApi::class)

package showcaseapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/showcaseapp.composeapp.generated.resources/"

@delegate:ResourceContentHash(-971_799_625)
internal val Res.string.local_source_name: StringResource by lazy {
      StringResource("string:local_source_name", "local_source_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17171, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19737, 49),
      ))
    }

@delegate:ResourceContentHash(1_364_955_516)
internal val Res.string.matrix_size: StringResource by lazy {
      StringResource("string:matrix_size", "matrix_size", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17217, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19787, 35),
      ))
    }

@delegate:ResourceContentHash(-1_409_162_261)
internal val Res.string.medium: StringResource by lazy {
      StringResource("string:medium", "medium", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17253, 18),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19823, 22),
      ))
    }

@delegate:ResourceContentHash(599_989_079)
internal val Res.string.membership: StringResource by lazy {
      StringResource("string:membership", "membership", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17272, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19846, 34),
      ))
    }

@delegate:ResourceContentHash(-1_320_061_089)
internal val Res.string.minutes: StringResource by lazy {
      StringResource("string:minutes", "minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17299, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19881, 27),
      ))
    }

@delegate:ResourceContentHash(1_725_016_791)
internal val Res.string.moderate: StringResource by lazy {
      StringResource("string:moderate", "moderate", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17323, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19909, 28),
      ))
    }

@delegate:ResourceContentHash(1_042_477_674)
internal val Res.string.mtphoto_album_required: StringResource by lazy {
      StringResource("string:mtphoto_album_required", "mtphoto_album_required", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17348, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19938, 62),
      ))
    }

@delegate:ResourceContentHash(-220_522_150)
internal val Res.string.mtphoto_albums_loaded: StringResource by lazy {
      StringResource("string:mtphoto_albums_loaded", "mtphoto_albums_loaded", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17411, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20001, 81),
      ))
    }

@delegate:ResourceContentHash(29_341_800)
internal val Res.string.mtphoto_api_key_required: StringResource by lazy {
      StringResource("string:mtphoto_api_key_required", "mtphoto_api_key_required", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17485, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20083, 68),
      ))
    }

@delegate:ResourceContentHash(-613_122_533)
internal val Res.string.mtphoto_browser_access_error: StringResource by lazy {
      StringResource("string:mtphoto_browser_access_error", "mtphoto_browser_access_error", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17554, 204),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20152, 216),
      ))
    }

@delegate:ResourceContentHash(-703_321_262)
internal val Res.string.mtphoto_password_required: StringResource by lazy {
      StringResource("string:mtphoto_password_required", "mtphoto_password_required", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17759, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20369, 69),
      ))
    }

@delegate:ResourceContentHash(-1_697_351_005)
internal val Res.string.mtphoto_username_required: StringResource by lazy {
      StringResource("string:mtphoto_username_required", "mtphoto_username_required", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17825, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20439, 69),
      ))
    }

@delegate:ResourceContentHash(-236_072_885)
internal val Res.string.music_album_link: StringResource by lazy {
      StringResource("string:music_album_link", "music_album_link", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17895, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20509, 52),
      ))
    }

@delegate:ResourceContentHash(-27_964_129)
internal val Res.string.my: StringResource by lazy {
      StringResource("string:my", "my", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17982, 18),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20612, 14),
      ))
    }

@delegate:ResourceContentHash(735_820_421)
internal val Res.string.my_collections_photos: StringResource by lazy {
      StringResource("string:my_collections_photos", "my_collections_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17936, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20562, 49),
      ))
    }

@delegate:ResourceContentHash(-1_903_781_885)
internal val Res.string.name_is_invalid: StringResource by lazy {
      StringResource("string:name_is_invalid", "name_is_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18001, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20627, 43),
      ))
    }

@delegate:ResourceContentHash(-249_047_214)
internal val Res.string.name_require_hint: StringResource by lazy {
      StringResource("string:name_require_hint", "name_require_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18041, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20671, 45),
      ))
    }

@delegate:ResourceContentHash(2_035_750_161)
internal val Res.string.network_display_mode_folders_and_files: StringResource by lazy {
      StringResource("string:network_display_mode_folders_and_files", "network_display_mode_folders_and_files", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18083, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20717, 70),
      ))
    }

@delegate:ResourceContentHash(614_119_525)
internal val Res.string.network_display_mode_folders_only: StringResource by lazy {
      StringResource("string:network_display_mode_folders_only", "network_display_mode_folders_only", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18154, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20788, 57),
      ))
    }

@delegate:ResourceContentHash(-715_163_967)
internal val Res.string.network_error: StringResource by lazy {
      StringResource("string:network_error", "network_error", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18212, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20846, 41),
      ))
    }

@delegate:ResourceContentHash(-192_173_294)
internal val Res.string.network_root_directory: StringResource by lazy {
      StringResource("string:network_root_directory", "network_root_directory", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18250, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20888, 50),
      ))
    }

@delegate:ResourceContentHash(-582_839_568)
internal val Res.string.network_unknown_error: StringResource by lazy {
      StringResource("string:network_unknown_error", "network_unknown_error", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18293, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20939, 49),
      ))
    }

@delegate:ResourceContentHash(1_380_501_295)
internal val Res.string.new_update_release: StringResource by lazy {
      StringResource("string:new_update_release", "new_update_release", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18339, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20989, 42),
      ))
    }

@delegate:ResourceContentHash(-366_710_402)
internal val Res.string.no_photo_selected: StringResource by lazy {
      StringResource("string:no_photo_selected", "no_photo_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18386, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21032, 49),
      ))
    }

@delegate:ResourceContentHash(-1_341_257_983)
internal val Res.string.notification_channel_id: StringResource by lazy {
      StringResource("string:notification_channel_id", "notification_channel_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21082, 59),
      ))
    }

@delegate:ResourceContentHash(-1_321_539_312)
internal val Res.string.notification_title: StringResource by lazy {
      StringResource("string:notification_title", "notification_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21142, 50),
      ))
    }

@delegate:ResourceContentHash(-118_736_930)
internal val Res.string.open_as_server: StringResource by lazy {
      StringResource("string:open_as_server", "open_as_server", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18432, 42),
      ))
    }

@delegate:ResourceContentHash(457_513_228)
internal val Res.string.open_source_license: StringResource by lazy {
      StringResource("string:open_source_license", "open_source_license", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18475, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21193, 55),
      ))
    }

@delegate:ResourceContentHash(-1_470_439_728)
internal val Res.string.orientation: StringResource by lazy {
      StringResource("string:orientation", "orientation", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18535, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21249, 35),
      ))
    }

@delegate:ResourceContentHash(582_287_798)
internal val Res.string.password: StringResource by lazy {
      StringResource("string:password", "password", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18563, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21285, 28),
      ))
    }

@delegate:ResourceContentHash(1_819_623_385)
internal val Res.string.path: StringResource by lazy {
      StringResource("string:path", "path", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18628, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21358, 20),
      ))
    }

@delegate:ResourceContentHash(-1_984_676_703)
internal val Res.string.path_is_invalid: StringResource by lazy {
      StringResource("string:path_is_invalid", "path_is_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18588, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21314, 43),
      ))
    }

@delegate:ResourceContentHash(-2_049_082_972)
internal val Res.string.permission_required: StringResource by lazy {
      StringResource("string:permission_required", "permission_required", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18649, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21379, 87),
      ))
    }

@delegate:ResourceContentHash(1_294_562_816)
internal val Res.string.pexels_api_key: StringResource by lazy {
      StringResource("string:pexels_api_key", "pexels_api_key", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18797, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21547, 42),
      ))
    }

@delegate:ResourceContentHash(-1_912_602_737)
internal val Res.string.pexels_api_key_help: StringResource by lazy {
      StringResource("string:pexels_api_key_help", "pexels_api_key_help", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18721, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21467, 79),
      ))
    }

@delegate:ResourceContentHash(-1_230_892_750)
internal val Res.string.photo_display_duration: StringResource by lazy {
      StringResource("string:photo_display_duration", "photo_display_duration", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18840, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21590, 62),
      ))
    }

@delegate:ResourceContentHash(-109_927_779)
internal val Res.string.photo_size: StringResource by lazy {
      StringResource("string:photo_size", "photo_size", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18895, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21653, 34),
      ))
    }

@delegate:ResourceContentHash(-1_776_287_469)
internal val Res.string.photo_spacing: StringResource by lazy {
      StringResource("string:photo_spacing", "photo_spacing", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18930, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21688, 41),
      ))
    }

@delegate:ResourceContentHash(641_353_272)
internal val Res.string.platforms_supported: StringResource by lazy {
      StringResource("string:platforms_supported", "platforms_supported", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 18968, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21730, 67),
      ))
    }

@delegate:ResourceContentHash(-62_091_986)
internal val Res.string.play: StringResource by lazy {
      StringResource("string:play", "play", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21798, 20),
      ))
    }

@delegate:ResourceContentHash(640_571_589)
internal val Res.string.please_choose_collection: StringResource by lazy {
      StringResource("string:please_choose_collection", "please_choose_collection", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19040, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21819, 68),
      ))
    }

@delegate:ResourceContentHash(1_629_461_349)
internal val Res.string.please_enter_your_api_key: StringResource by lazy {
      StringResource("string:please_enter_your_api_key", "please_enter_your_api_key", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19093, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21888, 69),
      ))
    }

@delegate:ResourceContentHash(-1_736_765_483)
internal val Res.string.please_enter_your_api_token: StringResource by lazy {
      StringResource("string:please_enter_your_api_token", "please_enter_your_api_token", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19163, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21958, 87),
      ))
    }

@delegate:ResourceContentHash(655_195_754)
internal val Res.string.port: StringResource by lazy {
      StringResource("string:port", "port", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19295, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22090, 20),
      ))
    }

@delegate:ResourceContentHash(-1_631_385_210)
internal val Res.string.port_is_invalid: StringResource by lazy {
      StringResource("string:port_is_invalid", "port_is_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19251, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22046, 43),
      ))
    }

@delegate:ResourceContentHash(2_091_115_564)
internal val Res.string.press_again_to_exit: StringResource by lazy {
      StringResource("string:press_again_to_exit", "press_again_to_exit", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19316, 51),
      ))
    }

@delegate:ResourceContentHash(-1_409_716_360)
internal val Res.string.privacy_policy: StringResource by lazy {
      StringResource("string:privacy_policy", "privacy_policy", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19368, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22111, 42),
      ))
    }

@delegate:ResourceContentHash(1_098_305_143)
internal val Res.string.prominent: StringResource by lazy {
      StringResource("string:prominent", "prominent", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19407, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22154, 29),
      ))
    }

@delegate:ResourceContentHash(-1_450_183_086)
internal val Res.string.published_at: StringResource by lazy {
      StringResource("string:published_at", "published_at", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19433, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22184, 36),
      ))
    }

@delegate:ResourceContentHash(1_204_096_347)
internal val Res.string.random: StringResource by lazy {
      StringResource("string:random", "random", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19470, 22),
      ))
    }

@delegate:ResourceContentHash(486_924_482)
internal val Res.string.rate: StringResource by lazy {
      StringResource("string:rate", "rate", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19493, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22221, 24),
      ))
    }

@delegate:ResourceContentHash(1_454_305_150)
internal val Res.string.recursive_source_folder: StringResource by lazy {
      StringResource("string:recursive_source_folder", "recursive_source_folder", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19522, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22246, 75),
      ))
    }

@delegate:ResourceContentHash(-567_437_416)
internal val Res.string.repo_name: StringResource by lazy {
      StringResource("string:repo_name", "repo_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19586, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22322, 25),
      ))
    }

@delegate:ResourceContentHash(453_994_162)
internal val Res.string.repo_owner: StringResource by lazy {
      StringResource("string:repo_owner", "repo_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19616, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22348, 26),
      ))
    }

@delegate:ResourceContentHash(-617_208_621)
internal val Res.string.repo_url_require_hint: StringResource by lazy {
      StringResource("string:repo_url_require_hint", "repo_url_require_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19647, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22375, 57),
      ))
    }

@delegate:ResourceContentHash(-488_081_609)
internal val Res.string.request_permission: StringResource by lazy {
      StringResource("string:request_permission", "request_permission", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19697, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22433, 50),
      ))
    }

@delegate:ResourceContentHash(-1_721_829_073)
internal val Res.string.retry: StringResource by lazy {
      StringResource("string:retry", "retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22484, 21),
      ))
    }

@delegate:ResourceContentHash(31_910_391)
internal val Res.string.reveal_effect: StringResource by lazy {
      StringResource("string:reveal_effect", "reveal_effect", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19740, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22506, 29),
      ))
    }

@delegate:ResourceContentHash(54_813_879)
internal val Res.string.row: StringResource by lazy {
      StringResource("string:row", "row", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19770, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22536, 15),
      ))
    }

@delegate:ResourceContentHash(-125_320_714)
internal val Res.string.rss_feed_hint: StringResource by lazy {
      StringResource("string:rss_feed_hint", "rss_feed_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19786, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22552, 137),
      ))
    }

@delegate:ResourceContentHash(436_236_244)
internal val Res.string.rss_feed_url: StringResource by lazy {
      StringResource("string:rss_feed_url", "rss_feed_url", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19920, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22690, 36),
      ))
    }

@delegate:ResourceContentHash(2_118_868_352)
internal val Res.string.s3_access_key: StringResource by lazy {
      StringResource("string:s3_access_key", "s3_access_key", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20024, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22782, 37),
      ))
    }

@delegate:ResourceContentHash(-814_047_356)
internal val Res.string.s3_access_key_hint: StringResource by lazy {
      StringResource("string:s3_access_key_hint", "s3_access_key_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 19965, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22727, 54),
      ))
    }

@delegate:ResourceContentHash(-1_895_599_942)
internal val Res.string.s3_bucket: StringResource by lazy {
      StringResource("string:s3_bucket", "s3_bucket", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20125, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22871, 25),
      ))
    }

@delegate:ResourceContentHash(1_231_643_175)
internal val Res.string.s3_bucket_hint: StringResource by lazy {
      StringResource("string:s3_bucket_hint", "s3_bucket_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20062, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22820, 50),
      ))
    }

@delegate:ResourceContentHash(590_179_320)
internal val Res.string.s3_endpoint: StringResource by lazy {
      StringResource("string:s3_endpoint", "s3_endpoint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20228, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22974, 31),
      ))
    }

@delegate:ResourceContentHash(-111_208_869)
internal val Res.string.s3_endpoint_hint: StringResource by lazy {
      StringResource("string:s3_endpoint_hint", "s3_endpoint_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20155, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22897, 76),
      ))
    }

@delegate:ResourceContentHash(-1_057_972_830)
internal val Res.string.s3_prefix: StringResource by lazy {
      StringResource("string:s3_prefix", "s3_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20351, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23101, 41),
      ))
    }

@delegate:ResourceContentHash(1_012_013_815)
internal val Res.string.s3_prefix_hint: StringResource by lazy {
      StringResource("string:s3_prefix_hint", "s3_prefix_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20264, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23006, 94),
      ))
    }

@delegate:ResourceContentHash(-867_753_375)
internal val Res.string.s3_region: StringResource by lazy {
      StringResource("string:s3_region", "s3_region", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20393, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23143, 25),
      ))
    }

@delegate:ResourceContentHash(-556_393_824)
internal val Res.string.s3_secret_key: StringResource by lazy {
      StringResource("string:s3_secret_key", "s3_secret_key", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20419, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23169, 37),
      ))
    }

@delegate:ResourceContentHash(1_366_545_968)
internal val Res.string.s3_use_ssl: StringResource by lazy {
      StringResource("string:s3_use_ssl", "s3_use_ssl", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20457, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23207, 38),
      ))
    }

@delegate:ResourceContentHash(1_720_059_933)
internal val Res.string.save: StringResource by lazy {
      StringResource("string:save", "save", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20537, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23283, 20),
      ))
    }

@delegate:ResourceContentHash(-920_871_851)
internal val Res.string.save_success: StringResource by lazy {
      StringResource("string:save_success", "save_success", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20500, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23246, 36),
      ))
    }

@delegate:ResourceContentHash(1_242_670)
internal val Res.string.second: StringResource by lazy {
      StringResource("string:second", "second", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20558, 18),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23304, 26),
      ))
    }

@delegate:ResourceContentHash(1_226_208_116)
internal val Res.string.select_folder: StringResource by lazy {
      StringResource("string:select_folder", "select_folder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23331, 41),
      ))
    }

@delegate:ResourceContentHash(780_911_997)
internal val Res.string.select_photos: StringResource by lazy {
      StringResource("string:select_photos", "select_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20577, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23373, 41),
      ))
    }

@delegate:ResourceContentHash(-1_548_925_028)
internal val Res.string.sentry_test_close: StringResource by lazy {
      StringResource("string:sentry_test_close", "sentry_test_close", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/sentry_test.commonMain.cvr", 10, 33),
        ResourceItem(setOf(), "${MD}values/sentry_test.commonMain.cvr", 10, 33),
      ))
    }

@delegate:ResourceContentHash(-1_935_909_963)
internal val Res.string.sentry_test_consent: StringResource by lazy {
      StringResource("string:sentry_test_consent", "sentry_test_consent", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/sentry_test.commonMain.cvr", 44, 111),
        ResourceItem(setOf(), "${MD}values/sentry_test.commonMain.cvr", 44, 103),
      ))
    }

@delegate:ResourceContentHash(-163_950_261)
internal val Res.string.sentry_test_description: StringResource by lazy {
      StringResource("string:sentry_test_description", "sentry_test_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/sentry_test.commonMain.cvr", 156, 243),
        ResourceItem(setOf(), "${MD}values/sentry_test.commonMain.cvr", 148, 255),
      ))
    }

@delegate:ResourceContentHash(1_019_265_589)
internal val Res.string.sentry_test_failed: StringResource by lazy {
      StringResource("string:sentry_test_failed", "sentry_test_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/sentry_test.commonMain.cvr", 400, 102),
        ResourceItem(setOf(), "${MD}values/sentry_test.commonMain.cvr", 404, 114),
      ))
    }

@delegate:ResourceContentHash(2_014_896_318)
internal val Res.string.sentry_test_not_initialized: StringResource by lazy {
      StringResource("string:sentry_test_not_initialized", "sentry_test_not_initialized", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/sentry_test.commonMain.cvr", 503, 219),
        ResourceItem(setOf(), "${MD}values/sentry_test.commonMain.cvr", 519, 215),
      ))
    }

@delegate:ResourceContentHash(2_024_820_054)
internal val Res.string.sentry_test_queued: StringResource by lazy {
      StringResource("string:sentry_test_queued", "sentry_test_queued", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/sentry_test.commonMain.cvr", 723, 286),
        ResourceItem(setOf(), "${MD}values/sentry_test.commonMain.cvr", 735, 278),
      ))
    }

@delegate:ResourceContentHash(-831_986_713)
internal val Res.string.sentry_test_rejected: StringResource by lazy {
      StringResource("string:sentry_test_rejected", "sentry_test_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/sentry_test.commonMain.cvr", 1010, 132),
        ResourceItem(setOf(), "${MD}values/sentry_test.commonMain.cvr", 1014, 148),
      ))
    }

@delegate:ResourceContentHash(-340_295_244)
internal val Res.string.sentry_test_send: StringResource by lazy {
      StringResource("string:sentry_test_send", "sentry_test_send", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/sentry_test.commonMain.cvr", 1143, 48),
        ResourceItem(setOf(), "${MD}values/sentry_test.commonMain.cvr", 1163, 44),
      ))
    }

@delegate:ResourceContentHash(291_774_754)
internal val Res.string.sentry_test_title: StringResource by lazy {
      StringResource("string:sentry_test_title", "sentry_test_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/sentry_test.commonMain.cvr", 1192, 61),
        ResourceItem(setOf(), "${MD}values/sentry_test.commonMain.cvr", 1208, 65),
      ))
    }

@delegate:ResourceContentHash(-1_512_876_174)
internal val Res.string.sentry_test_unsupported: StringResource by lazy {
      StringResource("string:sentry_test_unsupported", "sentry_test_unsupported", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/sentry_test.commonMain.cvr", 1254, 215),
        ResourceItem(setOf(), "${MD}values/sentry_test.commonMain.cvr", 1274, 235),
      ))
    }

@delegate:ResourceContentHash(-1_455_782_307)
internal val Res.string.settings: StringResource by lazy {
      StringResource("string:settings", "settings", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20615, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23415, 28),
      ))
    }

@delegate:ResourceContentHash(-2_009_808_747)
internal val Res.string.share: StringResource by lazy {
      StringResource("string:share", "share", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20768, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23576, 21),
      ))
    }

@delegate:ResourceContentHash(-1_034_958_265)
internal val Res.string.share_to_others: StringResource by lazy {
      StringResource("string:share_to_others", "share_to_others", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20640, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23444, 131),
      ))
    }

@delegate:ResourceContentHash(-96_683_095)
internal val Res.string.show_content_meta_info: StringResource by lazy {
      StringResource("string:show_content_meta_info", "show_content_meta_info", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20790, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23598, 62),
      ))
    }

@delegate:ResourceContentHash(326_415_282)
internal val Res.string.show_movie_from_selected_region: StringResource by lazy {
      StringResource("string:show_movie_from_selected_region", "show_movie_from_selected_region", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20849, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23661, 83),
      ))
    }

@delegate:ResourceContentHash(2_055_796_364)
internal val Res.string.show_password: StringResource by lazy {
      StringResource("string:show_password", "show_password", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20925, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23745, 41),
      ))
    }

@delegate:ResourceContentHash(281_288_366)
internal val Res.string.show_time_and_date: StringResource by lazy {
      StringResource("string:show_time_and_date", "show_time_and_date", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 20963, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23787, 50),
      ))
    }

@delegate:ResourceContentHash(1_704_625_775)
internal val Res.string.show_time_progress_indicator: StringResource by lazy {
      StringResource("string:show_time_progress_indicator", "show_time_progress_indicator", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21018, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23838, 76),
      ))
    }

@delegate:ResourceContentHash(-94_264_874)
internal val Res.string.showcase_about: StringResource by lazy {
      StringResource("string:showcase_about", "showcase_about", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21079, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23915, 30),
      ))
    }

@delegate:ResourceContentHash(480_607_277)
internal val Res.string.showcase_general: StringResource by lazy {
      StringResource("string:showcase_general", "showcase_general", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21110, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23946, 36),
      ))
    }

@delegate:ResourceContentHash(148_823_281)
internal val Res.string.showcase_info: StringResource by lazy {
      StringResource("string:showcase_info", "showcase_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23983, 29),
      ))
    }

@delegate:ResourceContentHash(199_277_459)
internal val Res.string.showcase_preview: StringResource by lazy {
      StringResource("string:showcase_preview", "showcase_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21143, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24013, 36),
      ))
    }

@delegate:ResourceContentHash(1_219_487_189)
internal val Res.string.showcase_source_settings: StringResource by lazy {
      StringResource("string:showcase_source_settings", "showcase_source_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 21176, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24050, 52),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("local_source_name", Res.string.local_source_name)
  map.put("matrix_size", Res.string.matrix_size)
  map.put("medium", Res.string.medium)
  map.put("membership", Res.string.membership)
  map.put("minutes", Res.string.minutes)
  map.put("moderate", Res.string.moderate)
  map.put("mtphoto_album_required", Res.string.mtphoto_album_required)
  map.put("mtphoto_albums_loaded", Res.string.mtphoto_albums_loaded)
  map.put("mtphoto_api_key_required", Res.string.mtphoto_api_key_required)
  map.put("mtphoto_browser_access_error", Res.string.mtphoto_browser_access_error)
  map.put("mtphoto_password_required", Res.string.mtphoto_password_required)
  map.put("mtphoto_username_required", Res.string.mtphoto_username_required)
  map.put("music_album_link", Res.string.music_album_link)
  map.put("my", Res.string.my)
  map.put("my_collections_photos", Res.string.my_collections_photos)
  map.put("name_is_invalid", Res.string.name_is_invalid)
  map.put("name_require_hint", Res.string.name_require_hint)
  map.put("network_display_mode_folders_and_files", Res.string.network_display_mode_folders_and_files)
  map.put("network_display_mode_folders_only", Res.string.network_display_mode_folders_only)
  map.put("network_error", Res.string.network_error)
  map.put("network_root_directory", Res.string.network_root_directory)
  map.put("network_unknown_error", Res.string.network_unknown_error)
  map.put("new_update_release", Res.string.new_update_release)
  map.put("no_photo_selected", Res.string.no_photo_selected)
  map.put("notification_channel_id", Res.string.notification_channel_id)
  map.put("notification_title", Res.string.notification_title)
  map.put("open_as_server", Res.string.open_as_server)
  map.put("open_source_license", Res.string.open_source_license)
  map.put("orientation", Res.string.orientation)
  map.put("password", Res.string.password)
  map.put("path", Res.string.path)
  map.put("path_is_invalid", Res.string.path_is_invalid)
  map.put("permission_required", Res.string.permission_required)
  map.put("pexels_api_key", Res.string.pexels_api_key)
  map.put("pexels_api_key_help", Res.string.pexels_api_key_help)
  map.put("photo_display_duration", Res.string.photo_display_duration)
  map.put("photo_size", Res.string.photo_size)
  map.put("photo_spacing", Res.string.photo_spacing)
  map.put("platforms_supported", Res.string.platforms_supported)
  map.put("play", Res.string.play)
  map.put("please_choose_collection", Res.string.please_choose_collection)
  map.put("please_enter_your_api_key", Res.string.please_enter_your_api_key)
  map.put("please_enter_your_api_token", Res.string.please_enter_your_api_token)
  map.put("port", Res.string.port)
  map.put("port_is_invalid", Res.string.port_is_invalid)
  map.put("press_again_to_exit", Res.string.press_again_to_exit)
  map.put("privacy_policy", Res.string.privacy_policy)
  map.put("prominent", Res.string.prominent)
  map.put("published_at", Res.string.published_at)
  map.put("random", Res.string.random)
  map.put("rate", Res.string.rate)
  map.put("recursive_source_folder", Res.string.recursive_source_folder)
  map.put("repo_name", Res.string.repo_name)
  map.put("repo_owner", Res.string.repo_owner)
  map.put("repo_url_require_hint", Res.string.repo_url_require_hint)
  map.put("request_permission", Res.string.request_permission)
  map.put("retry", Res.string.retry)
  map.put("reveal_effect", Res.string.reveal_effect)
  map.put("row", Res.string.row)
  map.put("rss_feed_hint", Res.string.rss_feed_hint)
  map.put("rss_feed_url", Res.string.rss_feed_url)
  map.put("s3_access_key", Res.string.s3_access_key)
  map.put("s3_access_key_hint", Res.string.s3_access_key_hint)
  map.put("s3_bucket", Res.string.s3_bucket)
  map.put("s3_bucket_hint", Res.string.s3_bucket_hint)
  map.put("s3_endpoint", Res.string.s3_endpoint)
  map.put("s3_endpoint_hint", Res.string.s3_endpoint_hint)
  map.put("s3_prefix", Res.string.s3_prefix)
  map.put("s3_prefix_hint", Res.string.s3_prefix_hint)
  map.put("s3_region", Res.string.s3_region)
  map.put("s3_secret_key", Res.string.s3_secret_key)
  map.put("s3_use_ssl", Res.string.s3_use_ssl)
  map.put("save", Res.string.save)
  map.put("save_success", Res.string.save_success)
  map.put("second", Res.string.second)
  map.put("select_folder", Res.string.select_folder)
  map.put("select_photos", Res.string.select_photos)
  map.put("sentry_test_close", Res.string.sentry_test_close)
  map.put("sentry_test_consent", Res.string.sentry_test_consent)
  map.put("sentry_test_description", Res.string.sentry_test_description)
  map.put("sentry_test_failed", Res.string.sentry_test_failed)
  map.put("sentry_test_not_initialized", Res.string.sentry_test_not_initialized)
  map.put("sentry_test_queued", Res.string.sentry_test_queued)
  map.put("sentry_test_rejected", Res.string.sentry_test_rejected)
  map.put("sentry_test_send", Res.string.sentry_test_send)
  map.put("sentry_test_title", Res.string.sentry_test_title)
  map.put("sentry_test_unsupported", Res.string.sentry_test_unsupported)
  map.put("settings", Res.string.settings)
  map.put("share", Res.string.share)
  map.put("share_to_others", Res.string.share_to_others)
  map.put("show_content_meta_info", Res.string.show_content_meta_info)
  map.put("show_movie_from_selected_region", Res.string.show_movie_from_selected_region)
  map.put("show_password", Res.string.show_password)
  map.put("show_time_and_date", Res.string.show_time_and_date)
  map.put("show_time_progress_indicator", Res.string.show_time_progress_indicator)
  map.put("showcase_about", Res.string.showcase_about)
  map.put("showcase_general", Res.string.showcase_general)
  map.put("showcase_info", Res.string.showcase_info)
  map.put("showcase_preview", Res.string.showcase_preview)
  map.put("showcase_source_settings", Res.string.showcase_source_settings)
}
